<div class="wrapper">
    <div class="m-box">
        <h2>
            {{'appointments.gui.labels.quotaMonthHmo' | translate}}
        </h2>
        <div *ngFor="let hmo of hmos; let i = index">
            <h3>{{ 'appointments.gui.hmo.' + hmo | translate }}</h3>
            <form [formGroup]="forms[i]">
                <table>
                    <thead>
                        <tr>
                            <th *ngFor="let month of months">{{ 'appointments.gui.month.' + month | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td *ngFor="let month of months">
                                <input class="search-patient-field menstrual-field input-top" [formControlName]="month" />
                                <h4 *ngIf="isNumber(forms[i].get(month)?.value) && appointmentsCounts[hmo]">
                                    {{ forms[i].get(month)?.value - (appointmentsCounts[hmo][month] || 0) }} : {{'appointments.gui.labels.balance' | translate}}
                                  </h4>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </form>
        </div>
    </div>
</div>
